export const pointColors = {
  WILL_VISITED: '#67718B',
  VISITING: '#1c74da',
  MISSED_VISIT: '#67718B',
  VISITED: '#137C55',
  NOT_VISITED: '#67718B',
}
